import React, { Component } from "react";

export default class Forms extends Component {
    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <input
                    type="text"
                    name="city"
                    placeholder="City"
                    className="col-xs-12 col-sm-5"
                />
                <input
                    type="text"
                    name="country"
                    placeholder="Country"
                    className="col-xs-12 col-sm-5"
                />
                <button className="col-xs-12 col-sm-11">Get weather</button>
            </form>
        );
    }
}
